module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADBaU/BaU/BaU/BaU/BaU/BaU/BaU//6Lb/6LZVrO7/zE07iMP/zE3/6Lb/zE3/6LYmcsyMAAAAEXRSTlMAYL//ACDP7/8A////399QUCMekiQAAACwSURBVHgB7dXPCsMwCMdxk181Tdd/7/+0y2FsEEa1TMqgfk/m8jkIErq0lHFQTkOLBjUWKAlbIC5QK2yABIZEhxJMJRXKMJVVCMaug0ZjVJUCcoaOrntsTa+O5gaxAB4QF/hAAh8owQnKXhD+DnoojcbuAM2tb/O5ZQcU0Kce0roB5LLsgAKKf02Hpnf9y77sgAKKW7PfWl8PzV0BnYQWH2ilzQfaqW7L79C6V6pOPQGcmao4jB0kygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3e8.png
// module id = 816
// module chunks = 0